// Geometry of the week grid, all in layout px.

// Height of one hour. 80px gives a 30-minute class room for two lines (class
// name + instructor) and a 15-minute class room for one.
export const HOUR_PX = 80;
export const PX_PER_MIN = HOUR_PX / 60;
export const DAY_PX = 24 * HOUR_PX;

// The shortest a block is ever drawn: one line of text. A class shorter than
// that keeps its real start and is drawn this tall.
export const MIN_BLOCK_PX = 23;
// Space between neighbouring blocks, so back-to-back classes never touch.
export const GAP_PX = 2;
// A block's visual length in minutes when it is drawn at MIN_BLOCK_PX, used by
// the overlap layout so very short classes never sit on top of each other.
export const MIN_VISUAL_MIN = Math.ceil((MIN_BLOCK_PX + GAP_PX) / PX_PER_MIN);

// More overlapping classes than this collapse: the first two stay visible and
// the rest go behind a "+N" chip in a column of OVERFLOW_COL_PX on the right.
export const MAX_LANES = 3;
export const OVERFLOW_COL_PX = 34;

// The blocks sit inside the day column with this much space on each side; the
// wider right edge keeps a strip of every slot clickable.
export const BLOCK_INSET_LEFT = 2;
export const BLOCK_INSET_RIGHT = 6;

export const GUTTER_PX = 56;
export const HEADER_PX = 58;

// Click-to-create and drag snap to the half hour.
export const SNAP_MIN = 30;

// The grid always shows the whole day, so any hour can be clicked to create a
// class; each week opens at its first class (CalendarGrid).
export const START_HOUR = 0;
export const END_HOUR = 24;
// Where a week with no classes opens.
export const DEFAULT_SCROLL_MINUTE = 7 * 60;

// Text line boxes in a block (13px class name on 15px lines, 12px details on
// 14px lines; keep in step with .wc-title / .wc-line in index.css) plus its
// vertical padding: the heights at which a 2nd, 3rd and 4th line fit. These
// line heights let a one-hour class (78px) hold a name wrapped to two lines
// and three detail lines.
export const TITLE_LINE_PX = 15;
export const DETAIL_LINE_PX = 14;
export const BLOCK_PAD_Y = 5;
export const LINE_THRESHOLDS = [
  TITLE_LINE_PX + DETAIL_LINE_PX + BLOCK_PAD_Y, // 2 lines
  TITLE_LINE_PX + DETAIL_LINE_PX * 2 + BLOCK_PAD_Y, // 3 lines
  TITLE_LINE_PX + DETAIL_LINE_PX * 3 + BLOCK_PAD_Y, // 4 lines
] as const;

// A block's horizontal padding (9px left, which holds the colour bar, and 6px
// right; see .wc-block) and the extra room the title leaves for the
// attendance dot.
export const BLOCK_PAD_X = 15;
export const NEED_ACTION_PAD_PX = 8;

// A class name that doesn't fit on one line wraps to two lines, or to three
// in a block narrower than this, instead of being cut to "One …".
export const VERY_NARROW_BLOCK_PX = 90;
